import { Link, Outlet } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';
import { Button } from '../components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_e2d19eae-21d9-4f5b-a36f-57b16cd8c13e/artifacts/91mwiq27_Aljabr-Laundry-Main-Logo-.png";

export default function CustomerLayout() {
  const { t, toggleLanguage, isRTL } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col bg-[#F8FAFC]" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Navbar */}
      <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-testid="customer-navbar">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center" data-testid="logo-link">
              <img src={LOGO_URL} alt="Aljabr Laundry" className="h-10 w-auto" />
            </Link>

            <div className="flex items-center">
              <Button
                variant="ghost"
                size="sm"
                onClick={toggleLanguage}
                className="text-slate-600 hover:text-[#0056A6] font-medium"
                data-testid="language-switcher"
              >
                <Globe className="h-4 w-4 me-1.5" />
                {t('language')}
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-white border-t border-slate-100 py-8 mt-auto" data-testid="customer-footer">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
          <img src={LOGO_URL} alt="Aljabr" className="h-8 mx-auto mb-3 opacity-60" />
          <p className="text-sm text-slate-400">
            {t('footerText')}
          </p>
          <p className="text-xs text-slate-300 mt-1">
            &copy; {new Date().getFullYear()} {t('allRightsReserved')}
          </p>
        </div>
      </footer>
    </div>
  );
}
